export default "__VITE_ASSET__CUBAF$w1__"